import { render, staticRenderFns } from "./SchoolCard.vue?vue&type=template&id=4466f7aa&scoped=true&"
import script from "./SchoolCard.vue?vue&type=script&lang=js&"
export * from "./SchoolCard.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCard.vue?vue&type=style&index=0&id=4466f7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4466f7aa",
  null
  
)

export default component.exports